import "core-js/modules/es.array.reduce";
import _regeneratorRuntime from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { needs, KeyringTraceFlag, immutableClass, readOnlyProperty, unwrapDataKey } from '@aws-crypto/material-management';
import { KMS_PROVIDER_ID, generateDataKey, encrypt, decrypt, kmsResponseToEncryptedDataKey } from './helpers';
import { regionFromKmsKeyArn, decomposeAwsKmsKeyArn } from './region_from_kms_key_arn';
export function KmsKeyringClass(BaseKeyring) {
  var KmsKeyring = /*#__PURE__*/function (_BaseKeyring) {
    _inherits(KmsKeyring, _BaseKeyring);

    var _super = _createSuper(KmsKeyring);

    function KmsKeyring(_ref) {
      var _this;

      var clientProvider = _ref.clientProvider,
          generatorKeyId = _ref.generatorKeyId,
          _ref$keyIds = _ref.keyIds,
          keyIds = _ref$keyIds === void 0 ? [] : _ref$keyIds,
          grantTokens = _ref.grantTokens,
          discovery = _ref.discovery,
          discoveryFilter = _ref.discoveryFilter;

      _classCallCheck(this, KmsKeyring);

      _this = _super.call(this);
      /* Precondition: This is an abstract class. (But TypeScript does not have a clean way to model this) */

      needs(_this.constructor !== KmsKeyring, 'new KmsKeyring is not allowed');
      /* Precondition: A noop KmsKeyring is not allowed. */

      needs(!(!discovery && !generatorKeyId && !keyIds.length), 'Noop keyring is not allowed: Set a keyId or discovery');
      /* Precondition: A keyring can be either a Discovery or have keyIds configured. */

      needs(!(discovery && (generatorKeyId || keyIds.length)), 'A keyring can be either a Discovery or have keyIds configured.');
      /* Precondition: Discovery filter can only be configured in discovery mode. */

      needs(discovery || !discovery && !discoveryFilter, 'Account and partition decrypt filtering are only supported when discovery === true');
      /* Precondition: A Discovery filter *must* be able to match something.
       * I am not going to wait to tell you
       * that no CMK can match an empty account list.
       * e.g. [], [''], '' are not valid.
       */

      needs(!discoveryFilter || discoveryFilter.accountIDs && discoveryFilter.accountIDs.length && !!discoveryFilter.partition && discoveryFilter.accountIDs.every(function (a) {
        return typeof a === 'string' && !!a;
      }), 'A discovery filter must be able to match something.');
      /* Precondition: All KMS key identifiers must be valid. */

      needs(!generatorKeyId || typeof regionFromKmsKeyArn(generatorKeyId) === 'string', 'Malformed arn.');
      needs(keyIds.every(function (keyArn) {
        return typeof regionFromKmsKeyArn(keyArn) === 'string';
      }), 'Malformed arn.');
      /* Precondition: clientProvider needs to be a callable function. */

      needs(typeof clientProvider === 'function', 'Missing clientProvider');
      readOnlyProperty(_assertThisInitialized(_this), 'clientProvider', clientProvider);
      readOnlyProperty(_assertThisInitialized(_this), 'keyIds', Object.freeze(keyIds.slice()));
      readOnlyProperty(_assertThisInitialized(_this), 'generatorKeyId', generatorKeyId);
      readOnlyProperty(_assertThisInitialized(_this), 'grantTokens', grantTokens);
      readOnlyProperty(_assertThisInitialized(_this), 'isDiscovery', !!discovery);
      readOnlyProperty(_assertThisInitialized(_this), 'discoveryFilter', discoveryFilter ? Object.freeze(_objectSpread(_objectSpread({}, discoveryFilter), {}, {
        accountIDs: Object.freeze(discoveryFilter.accountIDs)
      })) : discoveryFilter);
      return _this;
    }
    /* Keyrings *must* preserve the order of EDK's.  The generatorKeyId is the first on this list. */


    _createClass(KmsKeyring, [{
      key: "_onEncrypt",
      value: function () {
        var _onEncrypt2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(material) {
          var keyIds, clientProvider, generatorKeyId, grantTokens, dataKey, _flags, trace, unencryptedDataKey, flags, _iterator, _step, kmsKey, kmsEDK;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!this.isDiscovery) {
                    _context.next = 2;
                    break;
                  }

                  return _context.abrupt("return", material);

                case 2:
                  keyIds = this.keyIds.slice();
                  clientProvider = this.clientProvider, generatorKeyId = this.generatorKeyId, grantTokens = this.grantTokens;

                  if (!(generatorKeyId && !material.hasUnencryptedDataKey)) {
                    _context.next = 15;
                    break;
                  }

                  _context.next = 7;
                  return generateDataKey(clientProvider, material.suite.keyLengthBytes, generatorKeyId, material.encryptionContext, grantTokens);

                case 7:
                  dataKey = _context.sent;

                  if (dataKey) {
                    _context.next = 10;
                    break;
                  }

                  throw new Error('Generator KMS key did not generate a data key');

                case 10:
                  _flags = KeyringTraceFlag.WRAPPING_KEY_GENERATED_DATA_KEY | KeyringTraceFlag.WRAPPING_KEY_SIGNED_ENC_CTX | KeyringTraceFlag.WRAPPING_KEY_ENCRYPTED_DATA_KEY;
                  trace = {
                    keyNamespace: KMS_PROVIDER_ID,
                    keyName: dataKey.KeyId,
                    flags: _flags
                  };
                  material
                  /* Postcondition: The generated unencryptedDataKey length must match the algorithm specification.
                   * See cryptographic_materials as setUnencryptedDataKey will throw in this case.
                   */
                  .setUnencryptedDataKey(dataKey.Plaintext, trace).addEncryptedDataKey(kmsResponseToEncryptedDataKey(dataKey), KeyringTraceFlag.WRAPPING_KEY_ENCRYPTED_DATA_KEY | KeyringTraceFlag.WRAPPING_KEY_SIGNED_ENC_CTX);
                  _context.next = 16;
                  break;

                case 15:
                  if (generatorKeyId) {
                    keyIds.unshift(generatorKeyId);
                  }

                case 16:
                  /* Precondition: If a generator does not exist, an unencryptedDataKey *must* already exist.
                   * Furthermore *only* CMK's explicitly designated as generators can generate data keys.
                   * See cryptographic_materials as getUnencryptedDataKey will throw in this case.
                   */
                  unencryptedDataKey = unwrapDataKey(material.getUnencryptedDataKey());
                  flags = KeyringTraceFlag.WRAPPING_KEY_ENCRYPTED_DATA_KEY | KeyringTraceFlag.WRAPPING_KEY_SIGNED_ENC_CTX;
                  _iterator = _createForOfIteratorHelper(keyIds);
                  _context.prev = 19;

                  _iterator.s();

                case 21:
                  if ((_step = _iterator.n()).done) {
                    _context.next = 29;
                    break;
                  }

                  kmsKey = _step.value;
                  _context.next = 25;
                  return encrypt(clientProvider, unencryptedDataKey, kmsKey, material.encryptionContext, grantTokens);

                case 25:
                  kmsEDK = _context.sent;

                  /* clientProvider may not return a client, in this case there is not an EDK to add */
                  if (kmsEDK) material.addEncryptedDataKey(kmsResponseToEncryptedDataKey(kmsEDK), flags);

                case 27:
                  _context.next = 21;
                  break;

                case 29:
                  _context.next = 34;
                  break;

                case 31:
                  _context.prev = 31;
                  _context.t0 = _context["catch"](19);

                  _iterator.e(_context.t0);

                case 34:
                  _context.prev = 34;

                  _iterator.f();

                  return _context.finish(34);

                case 37:
                  return _context.abrupt("return", material);

                case 38:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[19, 31, 34, 37]]);
        }));

        function _onEncrypt(_x) {
          return _onEncrypt2.apply(this, arguments);
        }

        return _onEncrypt;
      }()
    }, {
      key: "_onDecrypt",
      value: function () {
        var _onDecrypt2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(material, encryptedDataKeys) {
          var keyIds, clientProvider, generatorKeyId, grantTokens, decryptableEDKs, cmkErrors, _iterator2, _step2, edk, dataKey, flags, trace;

          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  keyIds = this.keyIds.slice();
                  clientProvider = this.clientProvider, generatorKeyId = this.generatorKeyId, grantTokens = this.grantTokens;
                  if (generatorKeyId) keyIds.unshift(generatorKeyId);
                  /* If there are no key IDs in the list, keyring is in "discovery" mode and will attempt KMS calls with
                   * every ARN it comes across in the message. If there are key IDs in the list, it will cross check the
                   * ARN it reads with that list before attempting KMS calls. Note that if caller provided key IDs in
                   * anything other than a CMK ARN format, the Encryption SDK will not attempt to decrypt those data keys, because
                   * the EDK data format always specifies the CMK with the full (non-alias) ARN.
                   */

                  decryptableEDKs = encryptedDataKeys.filter(filterEDKs(keyIds, this));
                  cmkErrors = [];
                  _iterator2 = _createForOfIteratorHelper(decryptableEDKs);
                  _context2.prev = 6;

                  _iterator2.s();

                case 8:
                  if ((_step2 = _iterator2.n()).done) {
                    _context2.next = 29;
                    break;
                  }

                  edk = _step2.value;
                  dataKey = false;
                  _context2.prev = 11;
                  _context2.next = 14;
                  return decrypt(clientProvider, edk, material.encryptionContext, grantTokens);

                case 14:
                  dataKey = _context2.sent;
                  _context2.next = 20;
                  break;

                case 17:
                  _context2.prev = 17;
                  _context2.t0 = _context2["catch"](11);

                  /* Failures onDecrypt should not short-circuit the process
                   * If the caller does not have access they may have access
                   * through another Keyring.
                   */
                  cmkErrors.push(_context2.t0);

                case 20:
                  if (dataKey) {
                    _context2.next = 22;
                    break;
                  }

                  return _context2.abrupt("continue", 27);

                case 22:
                  /* Postcondition: The KeyId from KMS must match the encoded KeyID. */
                  needs(dataKey.KeyId === edk.providerInfo, 'KMS Decryption key does not match serialized provider.');
                  flags = KeyringTraceFlag.WRAPPING_KEY_DECRYPTED_DATA_KEY | KeyringTraceFlag.WRAPPING_KEY_VERIFIED_ENC_CTX;
                  trace = {
                    keyNamespace: KMS_PROVIDER_ID,
                    keyName: dataKey.KeyId,
                    flags: flags
                  };
                  /* Postcondition: The decrypted unencryptedDataKey length must match the algorithm specification.
                   * See cryptographic_materials as setUnencryptedDataKey will throw in this case.
                   */

                  material.setUnencryptedDataKey(dataKey.Plaintext, trace);
                  return _context2.abrupt("return", material);

                case 27:
                  _context2.next = 8;
                  break;

                case 29:
                  _context2.next = 34;
                  break;

                case 31:
                  _context2.prev = 31;
                  _context2.t1 = _context2["catch"](6);

                  _iterator2.e(_context2.t1);

                case 34:
                  _context2.prev = 34;

                  _iterator2.f();

                  return _context2.finish(34);

                case 37:
                  /* Postcondition: A CMK must provide a valid data key or KMS must not have raised any errors.
                   * If I have a data key,
                   * decrypt errors can be ignored.
                   * However, if I was unable to decrypt a data key AND I have errors,
                   * these errors should bubble up.
                   * Otherwise, the only error customers will see is that
                   * the material does not have an unencrypted data key.
                   * So I return a concatenated Error message
                   */
                  needs(material.hasValidKey() || !material.hasValidKey() && !cmkErrors.length, cmkErrors.reduce(function (m, e, i) {
                    return "".concat(m, " Error #").concat(i + 1, " \n ").concat(e.stack, " \n");
                  }, 'Unable to decrypt data key and one or more KMS CMKs had an error. \n '));
                  return _context2.abrupt("return", material);

                case 39:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this, [[6, 31, 34, 37], [11, 17]]);
        }));

        function _onDecrypt(_x2, _x3) {
          return _onDecrypt2.apply(this, arguments);
        }

        return _onDecrypt;
      }()
    }]);

    return KmsKeyring;
  }(BaseKeyring);

  immutableClass(KmsKeyring);
  return KmsKeyring;
}

function filterEDKs(keyIds, _ref2) {
  var isDiscovery = _ref2.isDiscovery,
      discoveryFilter = _ref2.discoveryFilter;
  return function filter(_ref3) {
    var providerId = _ref3.providerId,
        providerInfo = _ref3.providerInfo;

    /* Check for early return (Postcondition): Only AWS KMS EDK should be attempted. */
    if (providerId !== KMS_PROVIDER_ID) return false;
    /* Discovery keyrings can not have keyIds configured,
     * and non-discovery keyrings must have keyIds configured.
     */

    if (isDiscovery) {
      /* Check for early return (Postcondition): There is no discoveryFilter to further condition discovery. */
      if (!discoveryFilter) return true;
      /* If the providerInfo is an invalid ARN this will throw.
       * But, this function is also used to extract regions
       * from an CMK to generate a regional client.
       * This means it will NOT throw for something
       * that looks like a bare alias or key id.
       * However, these constructions will not have an account or partition.
       */

      var _decomposeAwsKmsKeyAr = decomposeAwsKmsKeyArn(providerInfo),
          account = _decomposeAwsKmsKeyAr.account,
          partition = _decomposeAwsKmsKeyAr.partition;
      /* Postcondition: The account and partition *must* match the discovery filter.
       * Since we are offering a runtime discovery of CMKs
       * it is best to have some form of filter on this.
       * The providerInfo is a CMK ARN and will have the account and partition.
       * By offering these levers customers can easily bound
       * the CMKs to ones they control without knowing the CMKs
       * when the AWS KMS Keyring is instantiated.
       */


      return discoveryFilter.partition === partition && discoveryFilter.accountIDs.some(function (a) {
        return a === account;
      });
    } else {
      /* Postcondition: The EDK CMK (providerInfo) *must* match a configured CMK. */
      return keyIds.includes(providerInfo);
    }
  };
}